import { defineMessages } from 'react-intl';

export const messages: {
	uploadErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	uploadErrorDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	uploadErrorTitle: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.attachment-field.edit.utils.on-upload-error.upload-error-title',
		defaultMessage: 'Error uploading attachment',
		description: 'Title displayed in the error flag when an attachment upload error has occurred.',
	},
	uploadErrorDescription: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.attachment-field.edit.utils.on-upload-error.upload-error-description',
		defaultMessage: 'An error occurred when uploading an attachment',
		description:
			'Description displayed in the error flag when a generic error occurs during an attachment upload.',
	},
});
